import { getCustomerByIdentifier, } from "../services/getCustomerByIdentifier.js";
import { isCustomerSuspended } from "./isCustomerSuspended.js";
export async function getCustomerAndSuspension(customerIdentifier, client) {
    const customer = await getCustomerByIdentifier({ customerIdentifier }, { client });
    const isSuspended = isCustomerSuspended(customer?.meta ?? []);
    return { customer, isSuspended };
}
